var App = App || {};

/* =========================================================================
Zag Parallax Plugin
========================================================================== */

// Example usage
/*
App.ZagParallax.initialize('.block-masthead', '.block-masthead__image', { divisor: 2 });
*/

// Note: the child element with the parallax image must have the class 'zag-parallax-bg' for the effect to work
// .block-masthead has a descendant with the class .block-masthead__image which has a descendant with the class .zag-parallax-bg
// css is applied to .zag-parallax-bg by zag-parallax.css

// the rate at which the parallax image moves relative to scroll can be updated
// 1: will increase the size of the image to fill the entire screen* and will appear to not move
// 2: will increase the size of the image to 2x the size of the screen* and will move at half the rate of scroll
// any numeric value can be used

// * it's more intricate than that - the image is sized up to cover every vertical pixel the component may appear on
// * so if the component is position at the top of the page and will never reach the bottom of the page, the image doesn't need to fill 100% of the browser
// * if the component starts below the fold, the image will need to be larger than the height of the browser

const ZagParallaxPlugin = (function () {

    const defaultOptions = { divisor: 1 };

    /* =========================================================================
    Helpers
    ========================================================================== */

    function validateInitializationOptions(parentSelector, childSelector, options) {
        let isValid = true;
        if (!parentSelector || typeof parentSelector !== 'string') {
            console.warn('[ZagParallax] parentSelector is missing or not a string. Initialization skipped.');
            isValid = false;
        }
        if (!childSelector || typeof childSelector !== 'string') {
            console.warn('[ZagParallax] childSelector is missing or not a string. Initialization skipped.');
            isValid = false;
        }
        if (options && typeof options.divisor !== 'undefined' && (typeof options.divisor !== 'number' || isNaN(options.divisor))) {
            console.warn('[ZagParallax] options.divisor is not a number. Defaulting to 1.', options);
            options.divisor = 1;
        }
        return isValid;
    }

    /* =========================================================================
    DOM Updates
    ========================================================================== */

    function updateParallaxBackground(parallaxContainer, backgroundElement, divisor) {
        const rect = parallaxContainer.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const containerOffsetTop = rect.top + scrollTop;
        const windowHeight = window.innerHeight;
        const containerHeight = parallaxContainer.offsetHeight;

        // Parallax coverage logic
        let backgroundScale;
        if (containerOffsetTop + containerHeight < windowHeight) {
            backgroundScale = containerOffsetTop;
        }
        else {
            backgroundScale = windowHeight - containerHeight;
        }
        const backgroundHeight = containerHeight + backgroundScale / divisor;
        const backgroundTopOffset = (scrollTop - containerOffsetTop) / divisor;

        backgroundElement.style.height = backgroundHeight + 'px';
        backgroundElement.style.marginTop = backgroundTopOffset + 'px';
    }

    /* =========================================================================
    Event Binding
    ========================================================================== */

    function bindParallaxEvents(parallaxContainer, backgroundElement, divisor) {
        function handleParallaxUpdate() {
            updateParallaxBackground(parallaxContainer, backgroundElement, divisor);
        }
        window.addEventListener('resize', handleParallaxUpdate);
        window.addEventListener('scroll', handleParallaxUpdate);
    }

    /* =========================================================================
    Initialization
    ========================================================================== */

    function initializeParallaxForElement(parallaxContainer, options) {
        options = Object.assign({}, defaultOptions, options);
        if (typeof options.divisor !== 'number' || isNaN(options.divisor)) {
            options.divisor = 1;
        }
        const backgroundElement = parallaxContainer.querySelector('.zag-parallax-bg');
        if (!backgroundElement) {
            console.warn('[ZagParallax] .zag-parallax-bg element not found in child:', parallaxContainer);
            return;
        }
        parallaxContainer.classList.add('zag-parallax');
        updateParallaxBackground(parallaxContainer, backgroundElement, options.divisor);
        bindParallaxEvents(parallaxContainer, backgroundElement, options.divisor);
    }

    /* =========================================================================
    Public API Exposure
    ========================================================================== */

    return {
        initialize: function (parentSelector, childSelector, options) {
            if (!validateInitializationOptions(parentSelector, childSelector, options)) return;
            const parents = document.querySelectorAll(parentSelector);
            if (parents.length === 0) {
                console.warn('[ZagParallax] No elements found for parentSelector:', parentSelector);
                return;
            }
            let foundChild = false;
            parents.forEach(function (parent) {
                const children = parent.querySelectorAll(childSelector);
                if (children.length === 0) {
                    console.warn('[ZagParallax] No elements found for childSelector within parent:', childSelector, parent);
                    return;
                }
                foundChild = true;
                children.forEach(function (child) {
                    initializeParallaxForElement(child, options);
                });
            });
            if (!foundChild) {
                console.warn('[ZagParallax] No child elements found for selector:', childSelector);
            }
        }
    };
})();

/* =========================================================================
App Namespace Exposure
========================================================================== */

App.ZagParallax = {
    initialize: function (parentSelector, childSelector, options) {
        ZagParallaxPlugin.initialize(parentSelector, childSelector, options);
    },
};